export const Steps = [
    {
        id: 1,
        label: "Identificação",
        step: true,
        completed: false,
    },
    {
        id: 2,
        label: "Documentação",
        step: false,
        pending: false,
        completed: false,
    },
]

export const CheckListItemsDeathByAccident = [
    {
        id: 1,
        label: "Ocorrência policial",
        send: false
    },
    {
        id: 2,
        label: "Contrato de financiamento",
        send: false
    },
    {
        id: 3,
        label: "Certidão de óbito",
        send: false
    },
    {
        id: 4,
        label: "Laudo do IML",
        send: false
    },
    {
        id: 5,
        label: "Cópia autenticada da carteira de habilitação",
        send: false
    },
]

export const CheckListItemsDeathByDisease = [
    {
        id: 1,
        label: "Contrato de financiamento",
        send: false
    },
    {
        id: 2,
        label: "Certidão de óbito",
        send: false
    },
    {
        id: 3,
        label: "Laudos e atestados médicos",
        send: false
    },
    {
        id: 4,
        label: "DPS",
        send: false
    },
]

export const CheckListItemsIncapacityByAccident = [
    {
        id: 1,
        label: "Ocorrência policial",
        send: false
    },
    {
        id: 2,
        label: "Contrato de  financiamento",
        send: false
    },
    {
        id: 3,
        label: "Carta de concessão de aposentadoria",
        send: false
    },
    {
        id: 4,
        label: "Publicação da aposentadoria no Diário Oficial",
        send: false
    },
    {
        id: 5,
        label: "DPS",
        send: false
    },
    {
        id: 6,
        label: "Cópia autenticada da carteira de habilitação",
        send: false
    },
]

export const CheckListItemsIncapacityByDisease = [
    {
        id: 1,
        label: "Contrato de Financiamento",
        send: false
    },
    {
        id: 2,
        label: "Carta de concessão de aposentadoria",
        send: false
    },
    {
        id: 3,
        label: "Publicação da aposentadoria no Diário Oficial",
        send: false
    },
    {
        id: 4,
        label: "Laudos e atestados médicos",
        send: false
    },
    {
        id: 5,
        label: "DPS",
        send: false
    },
]